import { render, staticRenderFns } from "./TextQuestion.vue?vue&type=template&id=d96ec3de&scoped=true"
import script from "./TextQuestion.vue?vue&type=script&lang=ts"
export * from "./TextQuestion.vue?vue&type=script&lang=ts"
import style0 from "./TextQuestion.vue?vue&type=style&index=0&id=d96ec3de&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96ec3de",
  null
  
)

export default component.exports